import { useContext } from "react";

import RiskFinancingContext
    from "./RiskFinancingContext";

export default function
useRiskFinancingContext() {

    const context =
        useContext(
            RiskFinancingContext
        );

    if (!context) {

        throw new Error(

            "useRiskFinancingContext must be used inside RiskFinancingProvider"

        );

    }

    return context;
}